<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-product`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.937 10.952L24.922 2.407a2 2 0 00-1.715 0L5.22 10.951a2 2 0 00-1.141 1.807V35.22a2 2 0 001.14 1.806l17.985 8.564a2 2 0 001.719 0l18.014-8.565a2 2 0 001.142-1.806v-22.46a2 2 0 00-1.143-1.807zM8.08 33.958V16.894l13.849 6.951.036.019.256 16.827L8.08 33.958zm32-17.068l-13.977 6.962-.136.062.252 16.632 13.86-6.59V16.89zM9.72 13.24l14.346-6.812 14.366 6.813-14.113 7.03a.666.666 0 01-.596 0L9.721 13.24z"/></svg>
</template>
<script>

export default {
  name: 'IconProduct',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
